import { c, FC } from 'lib/component-utils'

type Props = {
  as?: 'h1' | 'h2'
  tagline: string
  description?: string
  dark?: boolean
}

const Heading: FC<Props> = ({ as: Tag = 'h2', className, tagline, description, dark = false }) => {
  return (
    <div className={c`max-w-2xl mx-auto text-center ${dark} selection:bg-primary-800 ${className}`}>
      <Tag className={c`text-3xl font-medium ${dark} text-gray-100 | text-black`}>{tagline}</Tag>
      {description && (
        <p
          className={c`mt-2 text-lg ${dark} text-white/80 | text-gray-700`}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
    </div>
  )
}

export default Heading
